// This file was automatically generated from app.settings.patientTags.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.patientTags');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.patientTags');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.patientTags.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">Patient Tags</h1>', (opt_data.isPracticeAdmin || ! el8Globals.FEATURES.AdminManagedSettings) ? '<p>Manage which tags are available in your patient charts. Merging or editing tags will be reflected in all existing patient charts. Deleting a tag will not remove it from any charts.</p>' : '<p> Only admins can create and manage patient tags. </p>', '<div class="patient-tags-section"><div><div class="el8InlineBlock w22 padv10 el8StrongMiniHeading">Label</div></div><ul class="patient-tags-list el8SettingsTable el8Loading ebs-list-unstyled"></ul>', (opt_data.isPracticeAdmin || ! el8Globals.FEATURES.AdminManagedSettings) ? '<button class="add-trigger ebs-btn ebs-btn-default">+ Add Patient Tag</button>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.patientTags.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var patientTagList7195 = opt_data.patientTags;
  var patientTagListLen7195 = patientTagList7195.length;
  for (var patientTagIndex7195 = 0; patientTagIndex7195 < patientTagListLen7195; patientTagIndex7195++) {
    var patientTagData7195 = patientTagList7195[patientTagIndex7195];
    output.append('<li class="curated-list-item el8SettingsTableRow ebs-clearfix" data-id="', soy.$$escapeHtml(patientTagData7195.id), '"><div class="ebs-col-xs-8 el8SettingsTableCell padl0"><p class="padv10h5" style=\'word-break: break-word\'>');
    el8.template.appshared.patientTags.tag({tag: patientTagData7195.value}, output);
    output.append('</p></div><div class="ebs-col-xs-4 el8SettingsTableCell">', (! patientTagData7195.isShared && (opt_data.isPracticeAdmin || ! el8Globals.FEATURES.AdminManagedSettings)) ? '<div class="padv10 ebs-text-right"><a class="edit-trigger el8Link">edit</a><a class="merge-trigger el8Link ml10">merge</a><a class="remove-trigger el8Link ml10">remove</a></div>' : '', '</div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.patientTags.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsInlineForm" data-id="', soy.$$escapeHtml(opt_data.tagId), '"><ul class="pad5 ebs-list-unstyled"><li class="ebs-clearfix"><div class="ebs-col-xs-8 padl0 el8SettingsTableCell"><div class="w90"><input type="text" class="el8EditorTextareaWrap ebs-form-control" name="value" /></div></div></li></ul><div class="ml5 el8InlineBlock form-buttons"></div></form>');
  if (!opt_sb) return output.toString();
};
